import { render } from "./base-right.vue?vue&type=template&id=8ae59802"
import script from "./base-right.vue?vue&type=script&lang=js"
export * from "./base-right.vue?vue&type=script&lang=js"

import "./base-right.vue?vue&type=style&index=0&id=8ae59802&lang=css"

import exportComponent from "C:\\Users\\67026\\Desktop\\front1.0\\front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDrawer});
